/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { REGIONDATA_LOAD_FAILURE, REGIONDATA_LOAD_SUCCESS } from "Constants/ActionTypes";
import { IRegionDataState } from "Interfaces/SiteContent";

import { IGetRegionFailure, IGetRegionSuccess } from "./RegionAction";

const intialState: IRegionDataState = {
  regions: [],
  regionOptionList: [],
  regionLoadError: "",
};

/**
 * Reducer function to load CL regions.
 * @state the current state.
 * @action the action object we use to update state.
 */
const applyLoadRegions = (
  state: IRegionDataState,
  action: IGetRegionSuccess
): IRegionDataState => ({
  ...state,
  regions: action.regions,
  regionOptionList: action.regions.map((x) => ({
    key: x.clRegionName,
    text: x.clRegionName,
    id: x.clRegionId,
  })),
});

/**
 * Reducer function to load the failure to
 * fetch CL regions.
 * @state the current state.
 * @action the action object we use to update state.
 */
const applyLoadFailregions = (
  state: IRegionDataState,
  action: IGetRegionFailure
): IRegionDataState => ({
  ...state,
  regionLoadError: action.regionLoadError,
});

/**
 * Region reducer function
 * @state the current state.
 * @action the action object we use to update state.
 */
function regionReducer(state: IRegionDataState = intialState, action: any) {
  switch (action.type) {
    case REGIONDATA_LOAD_SUCCESS:
      return applyLoadRegions(state, action);
    case REGIONDATA_LOAD_FAILURE:
      return applyLoadFailregions(state, action);
    default:
      return state;
  }
}

export default regionReducer;
